<template>
	<div class="jointActivitywarp">
		<NavMenu/>
		<div class="containerBox">
			<div class="content_warp">
				<div class="titleBox">人力资源服务行业协会人才培养联合行动</div>
				<div class="p">以习近平同志为核心的党中央，围绕高质量发展提出一系列新思想、新论断，作出一系列新部署、新要求。我们党正团结带领全国人民以高质量发展全面推进中国式现代化，加快构建以实体经济为支撑的现代化产业体系，迫切需要大力发展人力资源服务业；促进人口高质量发展，迫切需要大力发展人力资源服务业；促进高质量充分就业，迫切需要大力发展人力资源服务业。新时代人力资源服务业高质量发展，现代化人力资源服务产业的建设，是时代的召唤，是国家的战略，是全体人力资源服务工作者的使命任务。</div>
				<div class="p">社会组织作为社会治理的主体，是市场经济的有益补充，要勇于担当、履职尽责，以服务为本，发挥好独特优势作用，大力培养人才，为人力资源服务业高质量稳定持续发展提供充足的人才支撑。人力资源服务行业协会要统筹国家政策、行业趋势和企业需求，以人力资源服务产业需求为导向，以构建现代化人力资源服务人才体系为目标，广泛开展经营管理、职业技能、专业技术、实用技术等各类培训，构建分级分类、综合一体化的培训体系，为从业人员搭建专业化、职业化的成长通道。</div>
				<div class="p">中国人才交流协会联合各省市人力资源服务行业协会，共同推广一系列人才培养项目，建立一体化、上下联动、共建共享、融合发展的工作系统，以实际行动促进新时代人力资源服务行业高质量发展。</div>
				<div class="seconedBox">
					<div class="titleBox">首批实施项目</div>
					<div class="databox">
						<div v-for="(item,i) in seconedData" :key="i" class="Itembox">
							<div class="num">0{{i+1}}</div>
							<div class="text">
								{{item.text}}
							</div>
						</div>
					</div>
				</div>
				<div class="threeBox">
					<div class="titleBox"> 首批联合协会</div>
					<div class="topLogo">
						<img src="../assets/imgs/logos/1.png">
						<div>中国人才交流协会</div>
					</div>
					<div class="logobox">
						<div v-for="(item,i) in threeData" :key="i" class="logoItem">
							<img :src="item.logo">
							<div class="text">{{item.name}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer/>
	</div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
export default {
	components: {
		NavMenu,
		Footer,
	},
	data() {
		return {
			img1: require("@/assets/imgs/lead/img1.png"),
			seconedData: [
				{ text: '开展工信部中小企业经营管理领军人才“促进大中小企业融通创新”专题培训——人力资源服务赋能方向高级研修班，培养一批行业领军人才，打造一批行业领军企业。' },
				{ text: '开展人力资源服务业高管能力提升课程，聚焦行业高管实际需求，培养中高级管理人才。' },
				{ text: '开展国内（外）游学活动，开阔视野，借鉴经验，加强国际交流合作。' },
				{ text: '开展人才测评师培训项目，推广人才测评技术，培养人才测评队伍，促进人才测评业务发展。' },
				{ text: '开展薪税师培训项目，推广薪税服务技术，培养薪税服务专业人才。' },
				{ text: '开展劳动人事争议调解员培训项目，培养人力资源服务企业劳动人事争议调解员队伍，拓展服务业务范围，促进劳动关系和谐稳定。' },
				{ text: '开展求职实用技术培训项目，帮助求职者提升能力水平，促进其求职。' },
				{ text: '开展人工智能培训项目，普及人工智能知识和技术，推动人力资源服务行业与人工智能等新技术融合。' },
			],
			threeData: [
				{ logo: require("@/assets/imgs/logos/2.png"), name: '北京人力资源服务行业协会' },
				{ logo: require("@/assets/imgs/logos/3.png"), name: '山西省人力资源服务行业协会' },
				{ logo: require("@/assets/imgs/logos/4.png"), name: '内蒙古人力资源协会' },
				{ logo: require("@/assets/imgs/logos/5.png"), name: '辽宁省人力资源和社会保障行业协会' },
				{ logo: require("@/assets/imgs/logos/6.png"), name: '上海人才服务行业协会' },
				{ logo: require("@/assets/imgs/logos/7.png"), name: '浙江省人力资源服务行业协会' },
				{ logo: require("@/assets/imgs/logos/8.png"), name: '安徽省人力资源服务协会' },
				{ logo: require("@/assets/imgs/logos/9.png"), name: '福建省人力资源服务行业协会' },
				{ logo: require("@/assets/imgs/logos/10.png"), name: '江西省人力资源发展协会' },
				{ logo: require("@/assets/imgs/logos/11.png"), name: '河南省人才交流协会' },
				{ logo: require("@/assets/imgs/logos/12.png"), name: '广东省人才交流协会' },
				{ logo: require("@/assets/imgs/logos/13.png"), name: '重庆市人才研究和人力资源服务协会' },
				{ logo: require("@/assets/imgs/logos/14.png"), name: '陕西省人力资源服务行业协会' },
				{ logo: require("@/assets/imgs/logos/15.png"), name: '青海省人力资源服务行业协会' },
				{ logo: require("@/assets/imgs/logos/16.png"), name: '宁波市人力资源服务行业协会' },
				{ logo: require("@/assets/imgs/logos/17.png"), name: '西安市人力资源服务行业协会' },
			]
		}
	},
	methods: {},
	filters: {
		timer: (value) => {
			return value.substring(0, 10);
		}
	},
}
</script>
<style lang="less" scoped>
.jointActivitywarp {
	width: 100%;
	margin: 0 auto;
	.containerBox {
		min-height: 600px;
		background: linear-gradient(180deg, #1136a8 0%, #1f67cc 51%, #1136a7 100%);
		background-image: url('../assets/imgs/train/bg3.jpg');
		background-size: 100% 100%;
		padding: 46px 0 32px 0;
		box-sizing: border-box;
		.content_warp {
			width: 1160px;
			margin: 0 auto;
			color: #fff;
			.titleBox {
				text-align: center;
				font-size: 24px;
				margin-bottom: 20px;
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: bold;
			}
			.p {
				font-size: 16px;
				text-indent: 32px;
				line-height: 32px;
			}
			.seconedBox {
				margin: 30px 0;
				.titleBox{
					font-size: 20px;
				}
				.databox {
					display: flex;
					flex-wrap: wrap;
					margin-top: 36px;
					.Itembox {
						width: 278px;
						height: 229px;
						background: rgba(204, 221, 255, 0.5);
						box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
						border-radius: 8px 8px 8px 8px;
						margin: 0 16px 16px 0;
						padding: 18px 16px 24px 16px;
						box-sizing: border-box;
						&:nth-child(4n) {
							margin-right: 0;
						}
						display: flex;
						flex-direction: column;
						text-align: center;
						.num {
							font-size: 18px;
							font-weight: bold;
							position: relative;
							margin-bottom: 16px;
							&::before {
								content: '';
								position: absolute;
								width: 22px;
								height: 0px;
								border: 1px solid #fff;
								opacity: 1;
								background: #fff;
								left: 50%;
								transform: translateX(-50%);
								top: 24px;
							}
						}
						.text {
							font-size: 16px;
							line-height: 30px;
							text-align: left;
						}
					}
				}
			}
			.threeBox {
				.titleBox{
					font-size: 20px;
				}
				margin: 30px 0;
				.topLogo {
					display: flex;
					flex-direction: row;
					align-items: center;
					align-content: center;
					justify-content: center;
					width: 278px;
					margin: 32px auto 16px auto;
					background: rgba(204, 221, 255, 0.5);
					box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
					border-radius: 8px 8px 8px 8px;
					padding: 12px 0 12px 0px;
					box-sizing: border-box;
					height: 70px;
					img {
						margin: 0 10px;
					}
					div {
						font-size: 15px;
						line-height: 24px;
					}
				}
				.logobox {
					display: flex;
					flex-wrap: wrap;
					margin-top: 36px;
					.logoItem {
						width: 278px;
						height: 70px;
						background: rgba(204, 221, 255, 0.5);
						box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
						border-radius: 8px 8px 8px 8px;
						margin: 0 16px 16px 0;
						padding: 12px 9px 12px 0;
						box-sizing: border-box;
						&:nth-child(4n) {
							margin-right: 0;
						}
						display: flex;
						flex-direction: row;
						align-items: center;
						align-content: center;
						img {
							margin: 0 9px;
						}
						.text {
							font-size: 15px;
							line-height: 24px;
							text-align: left;
						}
					}
				}
			}
		}
	}
}
</style>


